﻿import * as eventTypes from '../../../map/utils/eventTypes';
import * as layerTypes from '../../../map/utils/layerTypes';
import * as paths from '../../../map/utils/paths';
import { getRenderPixel } from 'ol/render.js';

export default class SwipeControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl, toolbarContainer) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.map = mapControl.map;
        this.toolbarContainer = toolbarContainer;
        this.elementId = 'map-action-' + this.classId + '-' + this.action.Id;
        this.active = false;
        this.containerId = 'swipe-modal-' + this.classId + '-' + this.action.Id;
        this.rangeId = 'swipe-range-' + this.classId + '-' + this.action.Id;
        this.rangeButtonsId = 'swipe-range-buttons-' + this.classId + '-' + this.action.Id;
        this.rangeLeftId = 'swipe-range-left-' + this.classId + '-' + this.action.Id;
        this.rangeRightId = 'swipe-range-right-' + this.classId + '-' + this.action.Id;
        this.rangeCloseId = 'swipe-range-close-' + this.classId + '-' + this.action.Id;
        this.checkCloseId = 'swipe-check-close-' + this.classId + '-' + this.action.Id;
        this.checkedLeft = {};
        this.checkedRight = {};
        this.configLayers = {};
        this.delay = 50;
        this.timeoutId = null;
        this.orientation = 'vertical';
        this.swipeActive = false;
        this.minDistance = 5;
        this.hysteresis = 1.3;
        this.lastX = null;
        this.lastY = null;
        this.prerenderer = this._getPrerender();
        this.postrenderer = this._getPostrender();
    }

    init() {
        this.menuContainer.append(this._getActionButtonTemplate());
        document.getElementById(this.elementId).addEventListener('click', this._actionButtonClickHandler());
        $event.register(eventTypes.USER_INTERACTION_STARTED, this._getUserInteractionStartedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_VISIBILITY_CHANGED, this._getLegendChangedHandler(), this, this.classId);
        if (this.action.Content != null && this.action.Content.trim().length > 0) {
            try {
                let content = JSON.parse(this.action.Content.trim());
                if (content.layers.length > 0) {
                    content.layers.forEach(layer => {
                        this.configLayers[layer.id] = layer;
                    });
                }
            } catch (err) {

            }
        }

        $('body').on('mouseup', () => {
            if (this.swipeActive) {
                this.swipeActive = false;
                this.lastX = null;
                this.lastY = null;
                this._enableSelection();
            }
        });

        $('#xpmap-' + this.mapControl.mapId + '-' + this.classId).on('mousemove', (evt) => {
            if (this.swipeActive) {
                let orientationChanged = this._detectOrientation(evt.originalEvent);

                if (orientationChanged) {
                    this._changeOrientation();
                }

                if (this.orientation == 'vertical') {
                    $('#' + this.rangeButtonsId).css('transform', 'translate(' + evt.originalEvent.offsetX + 'px, 0px)');
                    $('#' + this.rangeRightId).css('transform', 'translate(' + evt.originalEvent.offsetX + 'px, 0px)');
                    $('#' + this.rangeLeftId).css('transform', 'translate(' + evt.originalEvent.offsetX + 'px, 0px) translateX(-100%)');
                } else {
                    $('#' + this.rangeButtonsId).css('transform', 'translate(0px, ' + evt.originalEvent.offsetY + 'px)');
                    $('#' + this.rangeRightId).css('transform', 'translate(0px, ' + evt.originalEvent.offsetY + 'px)');
                    $('#' + this.rangeLeftId).css('transform', 'translate(0px, ' + evt.originalEvent.offsetY + 'px) translateY(-100%)');
                }
                this.mapControl.map.render();
                this._triggerSwipeChanged();
            }
        });
    }

    _changeOrientation() {
        if (this.orientation == 'vertical') {
            $('#' + this.containerId).removeClass('horizontal');
            $('#' + this.containerId).addClass('vertical');

            $('#' + this.rangeButtonsId).removeClass('horizontal');
            $('#' + this.rangeButtonsId).addClass('vertical');
        } else {
            $('#' + this.containerId).removeClass('vertical');
            $('#' + this.containerId).addClass('horizontal');

            $('#' + this.rangeButtonsId).removeClass('vertical');
            $('#' + this.rangeButtonsId).addClass('horizontal');
        }
    }

    _detectOrientation(e) {
        const x = e.clientX, y = e.clientY;
        if (this.lastX == null) {
            this.lastX = x;
            this.lastY = y;
            return false;
        }

        const dx = x - this.lastX;
        const dy = y - this.lastY;
        const ax = Math.abs(dx);
        const ay = Math.abs(dy);

        if (ax + ay < this.minDistance) {
            this.lastX = x;
            this.lastY = y;
            return false;
        }

        let next = this.orientation;

        if (this.orientation == 'vertical') {
            if (ay > ax * this.hysteresis) next = 'horizontal';
        } else if (this.orientation == 'horizontal') {
            if (ax > ay * this.hysteresis) next = 'vertical';
        } else {
            if (ax > ay * this.hysteresis) next = 'vertical';
            else if (ay > ax * this.hysteresis) next = 'horizontal';
        }

        this.lastX = x;
        this.lastY = y;

        if (next && next != this.orientation) {
            this.orientation = next;
            return true;
        } else {
            return false
        }
    }

    _disableSelection(scope = document.body) {
        scope.classList.add('no-select');
        scope.addEventListener('selectstart', this._prevent, { capture: true });
        scope.addEventListener('dragstart', this._prevent, { capture: true });
    }

    _enableSelection(scope = document.body) {
        scope.classList.remove('no-select');
        scope.removeEventListener('selectstart', this._prevent, { capture: true });
        scope.removeEventListener('dragstart', this._prevent, { capture: true });
        //const sel = window.getSelection?.();
        //sel && sel.removeAllRanges();
    }

    _getLegendChangedHandler() {
        var handler = (eventName, event, sender) => {
            if (this.active) {
                this._handleRefreshLayers(false);
            }
        };

        return handler;
    }

    _getUserInteractionStartedHandler() {
        var handler = (eventName, data, sender) => {
            this._hideToolbar();
        };

        return handler;
    }

    _actionButtonClickHandler() {
        return () => {
            if (this.active) {
                this._hideToolbar();
            } else {
                $event.notify(eventTypes.USER_INTERACTION_STARTED, {}, this, this.classId);
                this._showToolbar();
            }
        };
    }

    _hideToolbar() {
        this.checkedRight = {};
        this.checkedLeft = {};
        this._triggerSwipeChanged();
        this.toolbarContainer.innerHTML = '';
        $('#' + this.elementId).removeClass('selected');
        this.active = false;
        this.lastX = null;
        this.lastY = null;

        this.mapControl.map.getAllLayers().forEach(layer => {
            layer.un('prerender', this.prerenderer);
            layer.un('postrender', this.postrenderer);
        });
    }

    _showToolbar() {
        $('#' + this.elementId).addClass('selected');
        this.active = true;
        this.toolbarContainer.innerHTML = this._getToolbarTemplate();

        $('#' + this.rangeCloseId).on('click', () => {
            this._hideToolbar();
        });

        $('#' + this.checkCloseId).on('click', () => {
            if ($('#' + this.checkCloseId).hasClass('fa-check')) {
                $('#' + this.checkCloseId).removeClass('fa-check');
                $('#' + this.checkCloseId).addClass('fa-cog');
                $('#' + this.rangeLeftId).hide();
                $('#' + this.rangeRightId).hide();
            } else {
                $('#' + this.checkCloseId).removeClass('fa-cog');
                $('#' + this.checkCloseId).addClass('fa-check');
                $('#' + this.rangeLeftId).show();
                $('#' + this.rangeRightId).show();
            }
        });

        this._refreshLayers(true);
        this._handleCheck('right');
        this._handleCheck('left');

        this.mapControl.map.getAllLayers().forEach(layer => {
            layer.on('prerender', this.prerenderer);
            layer.on('postrender', this.postrenderer);
        });

        this._triggerSwipeChanged();

        $('#' + this.rangeButtonsId).on('mousedown', () => {
            this.swipeActive = true;
            this._disableSelection();
        });


    }

    _prevent(e) {
        e.preventDefault();
    }

    _getPostrender() {
        var handler = (event) => {
            let ctx = event.context;
            ctx.restore();
        }

        return handler;
    }

    _getPrerender() {
        var handler = (event) => {
            if (this.orientation == 'vertical') {
                this._getVerticalPrerenderer(event);
            } else {
                this._getHorizontalPrerenderer(event);
            }
        };

        return handler;
    }

    _positionRelativeTo(el, container) {
        const a = el.getBoundingClientRect();
        const b = container.getBoundingClientRect();
        return { top: a.top - b.top, left: a.left - b.left };
    }

    _getVerticalPrerenderer(event) {
        let max = $('#xpmap-' + this.mapControl.mapId + '-' + this.classId)[0].offsetWidth;
        let current = this._positionRelativeTo($('#' + this.rangeButtonsId)[0], $('#xpmap-' + this.mapControl.mapId + '-' + this.classId)[0]).left;

        if (event.target.get('uid') == null) {
            return;
        }

        if (this.checkedRight[event.target.get('uid')] == null || this.checkedLeft[event.target.get('uid')] == null) {
            return;
        }

        if (this.checkedRight[event.target.get('uid')] && this.checkedLeft[event.target.get('uid')]) {
            return;
        }

        if (this.checkedRight[event.target.get('uid')]) {
            let ctx = event.context;
            let mapSize = event.frameState.size;
            let width = mapSize[0] * (current / max);
            let tl = this._toLayerPixel(event, [width, 0]);
            let tr = this._toLayerPixel(event, [mapSize[0], 0]);
            let bl = this._toLayerPixel(event, [width, mapSize[1]]);
            let br = this._toLayerPixel(event, mapSize);

            ctx.save();
            ctx.beginPath();
            ctx.moveTo(tl[0], tl[1]);
            ctx.lineTo(bl[0], bl[1]);
            ctx.lineTo(br[0], br[1]);
            ctx.lineTo(tr[0], tr[1]);
            ctx.closePath();
            ctx.clip();
        }

        if (this.checkedLeft[event.target.get('uid')]) {
            let ctx = event.context;
            let mapSize = event.frameState.size;
            let width = mapSize[0] * (current / max);
            let tl = this._toLayerPixel(event, [0, 0]);
            let tr = this._toLayerPixel(event, [width, 0]);
            let br = this._toLayerPixel(event, [width, mapSize[1]]);
            let bl = this._toLayerPixel(event, [0, mapSize[1]])

            ctx.save();
            ctx.beginPath();
            ctx.moveTo(tl[0], tl[1]);
            ctx.lineTo(bl[0], bl[1]);
            ctx.lineTo(br[0], br[1]);
            ctx.lineTo(tr[0], tr[1]);
            ctx.closePath();
            ctx.clip();
        }

        if (!this.checkedRight[event.target.get('uid')] && !this.checkedLeft[event.target.get('uid')]) {
            let ctx = event.context;
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(0, 0);
            ctx.lineTo(0, 0);
            ctx.lineTo(0, 0);
            ctx.lineTo(0, 0);
            ctx.closePath();
            ctx.clip();
        }
    }

    _getHorizontalPrerenderer(event) {
        let max = $('#xpmap-' + this.mapControl.mapId + '-' + this.classId)[0].offsetHeight;
        let current = this._positionRelativeTo($('#' + this.rangeButtonsId)[0], $('#xpmap-' + this.mapControl.mapId + '-' + this.classId)[0]).top;

        if (event.target.get('uid') == null) {
            return;
        }

        if (this.checkedRight[event.target.get('uid')] == null || this.checkedLeft[event.target.get('uid')] == null) {
            return;
        }

        if (this.checkedRight[event.target.get('uid')] && this.checkedLeft[event.target.get('uid')]) {
            return;
        }

        if (this.checkedRight[event.target.get('uid')]) {
            let ctx = event.context;
            let mapSize = event.frameState.size;
            let height = mapSize[1] * (current / max);
            let tl = this._toLayerPixel(event, [0, height]);
            let tr = this._toLayerPixel(event, [0, mapSize[1]]);
            let bl = this._toLayerPixel(event, [mapSize[0], height]);
            let br = this._toLayerPixel(event, mapSize);

            ctx.save();
            ctx.beginPath();
            ctx.moveTo(tl[0], tl[1]);
            ctx.lineTo(bl[0], bl[1]);
            ctx.lineTo(br[0], br[1]);
            ctx.lineTo(tr[0], tr[1]);
            ctx.closePath();
            ctx.clip();
        }

        if (this.checkedLeft[event.target.get('uid')]) {
            let ctx = event.context;
            let mapSize = event.frameState.size;
            let height = mapSize[1] * (current / max);
            let tl = this._toLayerPixel(event, [0, 0]);
            let tr = this._toLayerPixel(event, [0, height]);
            let br = this._toLayerPixel(event, [mapSize[0], height]);
            let bl = this._toLayerPixel(event, [mapSize[0], 0])

            ctx.save();
            ctx.beginPath();
            ctx.moveTo(tl[0], tl[1]);
            ctx.lineTo(bl[0], bl[1]);
            ctx.lineTo(br[0], br[1]);
            ctx.lineTo(tr[0], tr[1]);
            ctx.closePath();
            ctx.clip();
        }

        if (!this.checkedRight[event.target.get('uid')] && !this.checkedLeft[event.target.get('uid')]) {
            let ctx = event.context;
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(0, 0);
            ctx.lineTo(0, 0);
            ctx.lineTo(0, 0);
            ctx.lineTo(0, 0);
            ctx.closePath();
            ctx.clip();
        }
    }

    _toLayerPixel(event, pixel) {
        const p = pixel.slice();
        if (event.inversePixelTransform) {
            p[0] = p[0] * event.inversePixelTransform[0] + event.inversePixelTransform[4];
            p[1] = p[1] * event.inversePixelTransform[3] + event.inversePixelTransform[5];
        }
        return p;
    }

    _handleRefreshLayers(reload) {
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => {
            this._refreshLayers(reload);
        }, this.delay);
    }

    _refreshLayers(reload) {
        let layers = this._getCurrentLayers();

        if ($('#' + this.rangeLeftId).data('kendoTreeView') != null) {
            $('#' + this.rangeLeftId).data('kendoTreeView').destroy();
        }

        if ($('#' + this.rangeRightId).data('kendoTreeView') != null) {
            $('#' + this.rangeRightId).data('kendoTreeView').destroy();
        }

        $('#' + this.rangeLeftId).kendoTreeView({
            loadOnDemand: false,
            dataSource: new kendo.data.HierarchicalDataSource({
                data: layers, schema: {
                    model: {
                        id: "id",
                        children: "items"
                    }
                }
            }),
            dragAndDrop: false,
            dataTextField: "title",
            checkboxes: {
                checkChildren: true
            },
            template: (e) => {
                return this._getLayerTemplate(e.item);
            },
            check: (e) => {
                this._handleCheck('left');
                this._triggerSwipeChanged();
                this.mapControl.map.render();
            }
        });

        $('#' + this.rangeRightId).kendoTreeView({
            loadOnDemand: false,
            dataSource: new kendo.data.HierarchicalDataSource({
                data: layers, schema: {
                    model: {
                        id: "id",
                        children: "items"
                    }
                }
            }),
            dragAndDrop: false,
            dataTextField: "title",
            checkboxes: {
                checkChildren: true
            },
            template: (e) => {
                return this._getLayerTemplate(e.item);
            },
            check: (e) => {
                this._handleCheck('right');
                this._triggerSwipeChanged();
                this.mapControl.map.render();
            }
        });
    }

    _handleCheck(flavour) {
        let items = null;

        if (flavour == 'right') {
            items = $('#' + this.rangeRightId).data('kendoTreeView').dataSource.data();
        } else {
            items = $('#' + this.rangeLeftId).data('kendoTreeView').dataSource.data();
        }

        this._handleLayersCheck(flavour, items);
    }

    _handleLayersCheck(flavour, layers) {
        let flavourHolder = null;

        if (flavour == 'right') {
            flavourHolder = this.checkedRight;
        } else {
            flavourHolder = this.checkedLeft;
        }

        layers.forEach(layer => {
            if (layer.type != layerTypes.GROUP) {
                flavourHolder[layer.id] = layer.checked;
            } else if (layer.items != null && layer.items.length > 0) {
                this._handleLayersCheck(flavour, layer.items);
            }
        });
    }

    _getLayerTemplate(layer) {
        return `<div class="map-print-layer">` + this._getLegendIcon(layer) + `<span class="map-print-layer-name" style="font-size: 0.75rem;">` + layer.title + `</span></div>`;
    }

    _getLegendIcon(layer) {
        let template = ``;

        if (layer.id == layerTypes.MEASUREMENTS) {
            template = `<span class="fal fa-ruler legend-preview-icon" style="font-size: 1rem; margin-left: 4px; margin-right: 3px;"></span>`;
        }
        else if (layer.id == layerTypes.DIMENSIONING) {
            template = `<span class="fal fa-arrows-h legend-preview-icon" style="font-size: 1rem; margin-left: 4px; margin-right: 3px;"></span>`;
        }
        else if (layer.id == layerTypes.REDLINE) {
            template = `<span class="fal fa-pencil-paintbrush legend-preview-icon" style="font-size: 1rem; margin-left: 4px; margin-right: 3px;"></span>`;
        }
        else if (layer.type == layerTypes.GROUP) {
            template = `<span class="fal fa-object-group legend-preview-icon" style="font-size: 1rem; margin-right: 3px;"></span>`;
        } else if (layer.type == layerTypes.GEOSERVICE) {
            if (layer.geoservice.LegendUrl != null && layer.geoservice.LegendUrl.trim() != '') {
                template = `<img style="height: 24px; width: 24px;" class="legend-preview-image" src="` + (this.rootURL + paths.PROXY_URL + this.mapId + '/' + layer.fid.replaceAll('-', '') + layer.geoservice.LegendUrl) + `"></img>`;
            } else {
                template = `<span class="fal fa-globe legend-preview-icon" style="font-size: 1rem; margin-right: 3px;"></span>`;
            }
        }

        if (layer.style != null && layer.style > 0) {
            template = `<img style="height: 24px; width: 24px;" class="legend-preview-image" src="` + (this.rootURL + paths.LAYER_PREVIEW_URL.replaceAll('{id}', layer.style).replaceAll('{rule}', 0)) + `"></img>`;
        }

        return template;
    }

    _getCurrentLayers() {
        let layerTree = [];
        this._populateLayerTree(layerTree, this.layerSettingsHandler.layers);
        return layerTree;
    }

    _populateLayerTree(result, layers) {
        layers.forEach(layer => {
            if (layer.VisibleByDefault) {
                let treeLayer = {
                    id: layer.Id,
                    title: layer.Title,
                    type: layer.Type,
                    fid: layer.Fid,
                    geoservice: layer.Geoservice,
                    style: layer.IdDefaultStyle,
                    checked: true
                };


                if (layer.Type == layerTypes.GROUP) {
                    treeLayer.items = [];
                    this._populateLayerTree(treeLayer.items, layer.Items);
                }

                result.push(treeLayer);
            }
        });
    }

    _triggerSwipeChanged() {
        $event.notify(eventTypes.SWIPE_CHANGED, { checkedRight: this.checkedRight, checkedLeft: this.checkedLeft, swipeX: 0, swipeY: 0 }, this, this.classId);
    }

    _getToolbarTemplate() {
        return `<div id="` + this.containerId + `" class="swipe-modal ` + (this.orientation == 'vertical' ? `vertical` : `horizontal`) + `" style="width: ` + $('#xpmap-' + this.mapControl.mapId + '-' + this.classId)[0].offsetWidth + `px;">
                    <div id="` + this.rangeLeftId + `" class="swipe-layers p-2 left" style="transform: translate(` + (this.orientation == 'vertical' ? (($('#xpmap-' + this.mapControl.mapId + '-' + this.classId)[0].offsetWidth / 2) + 'px, 0px') : ('0px, ' + ($('#xpmap-' + this.mapControl.mapId + '-' + this.classId)[0].offsetHeight / 2) + 'px')) + `) translate` + (this.orientation == 'vertical' ? 'X' : 'Y') + `(-100%);"></div>
                    <div id="` + this.rangeButtonsId + `" class="swipe-range-buttons ` + (this.orientation == 'vertical' ? `vertical` : `horizontal`) + `" style="transform: translate(` + (this.orientation == 'vertical' ? (($('#xpmap-' + this.mapControl.mapId + '-' + this.classId)[0].offsetWidth / 2) + 'px, 0px') : ('0px, ' + ($('#xpmap-' + this.mapControl.mapId + '-' + this.classId)[0].offsetHeight / 2) + 'px')) + `);">
                        <div class="swipe-range-buttons-wrapper">
                            <button class="btn btn-primary fal fa-times mt-2" style="width: 2rem; height: 2rem;" id="` + this.rangeCloseId + `"></button>
                            <button class="btn btn-primary fal fa-check mt-2" style="width: 2rem; height: 2rem;" id="` + this.checkCloseId + `"></button>
                        </div>
                    </div>
                    <div id="` + this.rangeRightId + `" class="swipe-layers p-2 right" style="transform: translate(` + (this.orientation == 'vertical' ? (($('#xpmap-' + this.mapControl.mapId + '-' + this.classId)[0].offsetWidth / 2) + 'px, 0px') : ('0px, ' + ($('#xpmap-' + this.mapControl.mapId + '-' + this.classId)[0].offsetHeight / 2) + 'px')) + `);"></div>
                </div>`;
    }

    _getActionButtonTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<li>
                            <a class="btn map-menu-item" id="` + this.elementId + `" title="` + this._getTitle() + `">
                                <i class="` + this.action.Icon + `"></i>
                            </a>
                        </li>`;
        return div.firstChild;
    }

    _getTitle() {
        if (this.action.Title != null && this.action.Title != '') {
            return this.action.Title;
        }

        return this.resourcesHandler.get('SubType_' + this.action.SubType);
    }
}